import React, { Component } from 'react'
import { Button, Tooltip } from 'antd'
import { Row, Col, Field } from '../../../../../../styles'
import { withTranslation, Trans } from 'react-i18next'

class PrivacySelector extends Component {
  onClick = id => {
    const { onChange } = this.props

    if (onChange) {
      onChange(id)
    }
  }

  render() {
    const { types, t, isAdmin, checkSelectedType } = this.props
    return (
      <Field>
        <Field.Label>{t('labels:privacy_settings')}</Field.Label>
        <div style={{ paddingBottom: '10px' }}>
          {!isAdmin && (
            <Trans i18nKey="helpers:public_description_normal">
              <span>{t('labels:maze')}</span>
            </Trans>
          )}
          {isAdmin && (
            <Trans i18nKey="helpers:public_description_admin">
              <span>{t('labels:maze')}</span>
            </Trans>
          )}
        </div>
        <Field.Control>
          <Row>
            {types.map(type => (
              <Col md={12 / types.length} key={type.id}>
                {type.name === 'Marketplace' && type.disabled ? (
                  <Tooltip
                    placement="bottom"
                    title={isAdmin ? t('v4:not_complete') : t('v4:not_admin')}
                  >
                    <Button block icon="exclamation-circle" disabled>
                      {type.name}
                    </Button>
                  </Tooltip>
                ) : (
                  <Button
                    block
                    type={checkSelectedType(type.id) ? 'primary' : ''}
                    onClick={() => this.onClick(type.id)}
                  >
                    {type.name}
                  </Button>
                )}
              </Col>
            ))}
          </Row>
        </Field.Control>
      </Field>
    )
  }
}

export default withTranslation()(PrivacySelector)
